import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import isEqual from "lodash/isEqual"
import {
  Context,
  StudyPlanV2AdminManageStudyPlansSchema,
  Transitions
} from "../../../types"

import {
  getCurrentPlanTransition,
  getRecommendedPlanTransition
} from "../../../transitionalStates"
import { getAdminRelevantPlanInfoTransition } from "../../../states/admin/transitionalStates"
import {
  addLessonDrawerState,
  lessonDetailsDrawerState
} from "../../../states/drawers"

export const spv2AdminManageStudyPlansState: StateNodeConfig<
  Context,
  StudyPlanV2AdminManageStudyPlansSchema,
  Transitions,
  BaseActionObject
> = {
  id: "sp_v2_admin_manage_study_plans_state",
  initial: "loading",
  entry: assign<Context>(() => ({
    previousParentState: "sp_v2_admin_manage_study_plans_state"
  })),
  states: {
    loading: { ...getAdminRelevantPlanInfoTransition },

    get_current_plan: {
      ...getCurrentPlanTransition
    },
    get_recommended_plan_info_transition: {
      ...getRecommendedPlanTransition
    },

    add_lesson: { ...addLessonDrawerState },
    lesson_detail_view: { ...lessonDetailsDrawerState },

    idle: {
      on: {
        VIEW_RECOMMENDED_PLAN: {
          target: "get_recommended_plan_info_transition"
        },
        EDIT: {
          target: "#StudyPlan.edit_plan",
          cond: ctx => !!ctx.studyPlan
        },
        BUILD_STUDY_PLAN: {
          target: "#StudyPlan.edit_published_plan_transition"
        },
        ADD_LESSON_TO_SECTION: {
          target: "add_lesson",
          actions: assign((_ctx, { sectionId }) => ({
            selectedSectionId: sectionId
          }))
        },
        VIEW_DETAILS: {
          target: "lesson_detail_view",
          actions: assign((_ctx, { sectionId, lessonId }) => ({
            selectedSectionId: sectionId,
            selectedLessonId: lessonId,
            lessonDetailViewModal: true
          }))
        },
        UPDATE_REPORTING_FILTERS_STATE: {
          target: "get_current_plan",
          cond: (ctx, event) => {
            if (ctx.user.role === "School Admin") {
              return false
            }

            const schoolId = event.state?.school?.[0]

            if (
              !isEqual(ctx.reportingFiltersState?.school, event.state?.school)
            ) {
              if (!schoolId) {
                return true
              }

              const schoolPlan = ctx.relevantSchoolPlansInfo.find(
                entity => entity.entityId === schoolId
              )

              return !!schoolPlan
            }

            return false
          }
        }
      }
    }
  }
}
